export const isArabic = (text) => {
  // Check if the text contains Arabic characters
  return /[\u0600-\u06FF]/.test(text);
}